module.exports = __webpack_public_path__ + "static/beam-fabrication-d81370fbe1d6e36cef10aead689225a9.jpg";